import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿En qué formato recibo el material?',
  answer: 'Todos los recursos se entregan en formato digital PDF de alta calidad. Puedes imprimirlos, proyectarlos o utilizarlos directamente desde una computadora, tableta o teléfono.'
}, {
  question: '¿Sirve para docentes de toda Latinoamérica?',
  answer: 'Sí. El material trabaja los contenidos fundamentales de química que se enseñan en educación secundaria. Cada docente puede seleccionar, organizar y adaptar los recursos de acuerdo con el programa de su país o institución.'
}, {
  question: '¿Puedo utilizarlo en clases particulares o talleres?',
  answer: 'Sí. Puedes utilizarlo en instituciones educativas, clases particulares, espacios de apoyo y talleres de ciencias. El material no puede revenderse, compartirse públicamente ni distribuirse como producto propio.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Una vez confirmado el pago, recibirás el acceso al material digital en el correo electrónico que indiques al momento de la compra.'
}, {
  question: '¿El precio está en dólares?',
  answer: 'El precio está expresado en dólares estadounidenses. Al ingresar al checkout, la plataforma mostrará la conversión automática a tu moneda local según tu país y el medio de pago disponible.'
}, {
  question: '¿Cómo funciona la conversión a mi moneda local?',
  answer: 'La conversión es automática. Al llegar al checkout, verás el importe convertido a tu moneda local de acuerdo con tu país y el medio de pago disponible, sin que tengas que hacer ningún cálculo.'
}, {
  question: '¿El pago es seguro?',
  answer: 'Sí. La operación se realiza mediante una pasarela de pago segura y protegida. Los datos personales y financieros son procesados directamente por la plataforma de pago.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí. La compra cuenta con una garantía de satisfacción de 7 días, de acuerdo con las condiciones informadas en esta página.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-6 md:py-12 px-4 bg-sky-200/30" data-id="element-44" data-mp="2ku3quyhz4yut">
      <div className="max-w-3xl mx-auto" data-id="element-45" data-mp="2fxlog5a49cln">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-black text-center text-slate-900 mb-6 md:mb-10" data-id="element-46" data-mp="2fuhawharh4ib">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-3" data-id="element-47" data-mp="2ynbhamubjoax">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-blue-100 overflow-hidden shadow-sm" data-id="element-48" data-mp="2yli9h47yyy1c" data-mpi={index}>
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full p-5 md:p-6 text-left flex justify-between items-center gap-4" data-id="element-49" data-mp="3uu6g84sv8igb">
                <span className="font-black text-slate-900 text-sm md:text-lg leading-tight" data-id="element-50" data-mp="2o19q9plk3kh">
                  {faq.question}
                </span>
                <div className="shrink-0 text-blue-600" data-id="element-51" data-mp="cg6yzbogs6vz">
                  {openIndex === index ? <Minus size={20} data-id="element-52" data-mp="hfa40w4g2d3y" /> : <Plus size={20} data-id="element-53" data-mp="hftbfiwgxj3q" />}
                </div>
              </button>
              <AnimatePresence data-id="element-54" data-mp="mduy0dt3s0jy">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-55" data-mp="mca2akv1ybki">
                    <div className="px-5 md:px-6 pb-6 text-slate-600 font-medium text-xs md:text-base leading-relaxed" data-id="element-56" data-mp="2x5mo8281bnji">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}